/**
 * @generated SignedSource<<212e76d400df0fff3d1c39b1c5efbb05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
import { FragmentRefs } from "relay-runtime";
export type SuggestedActions_note$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
  };
  readonly event: {
    readonly conferenceCalls: ReadonlyArray<{
      readonly provider: ConferenceCallProvider;
      readonly url: string;
    }>;
    readonly hasUsersWithExternalEmail: boolean;
    readonly isOneOnOne: boolean;
  } | null;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly artifactsReady: boolean;
    readonly id: string;
  }> | null;
  readonly viewerSentMeetingFeedback: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskFellowButton_note" | "AutoSendToEveryone_autoShareIsSetToEveryone_note" | "AutoSendToEveryone_note" | "CarryForward_note" | "EndMeeting_note" | "FilterByCompany_note" | "MeetingBriefsSuggestedAction_note" | "MeetingBriefs_useShowMeetingBriefSuggestedAction">;
  readonly " $fragmentType": "SuggestedActions_note";
};
export type SuggestedActions_note$key = {
  readonly " $data"?: SuggestedActions_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestedActions_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestedActions_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerSentMeetingFeedback",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOneOnOne",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "conferenceCalls",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "provider",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUsersWithExternalEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "artifactsReady",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EndMeeting_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CarryForward_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoSendToEveryone_note"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "meetingRecapAutoShareSource",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_S",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "StreamMeetingRecapAutoShareSettings",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_U",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "UserMeetingRecapAutoShareSettings",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowHooks_useAskFellowButton_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingBriefsSuggestedAction_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingBriefs_useShowMeetingBriefSuggestedAction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FilterByCompany_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "6b289b686af52a64e952a7cfbc37fb2b";

export default node;
